import './index.less'
import VisibleComponent from '../VisibleComponent'
import Panel from "../Panel"
import Mask from "../Mask"
import Button from "../Button"

const template = `
    <div class="mtg-dialog-wrap"></div>
`
const contentTemplate = `
    <div class="mtg-dialog-content-wrap">
        <div class="mtg-dialog-content"></div>
        <div class="mtg-dialog-btn-group"></div>
    </div>
`

/**
 * Panel 弹窗类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Dialog extends VisibleComponent {
    constructor(options = {}) {
        super(options)

        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        const {
            width = '75%',
            height = 'auto',
            title = 'Tips',
            padding,
            content,
            buttonGroup = [],
            overlayerOpacity,
            wrapClassName = '',
            titleClassName = '',
            contentClassName = '',
            titleAlign,
            titleTools = [],
        } = options

        this.dialogContent = this._parseHTML(contentTemplate)
        this.panelContent = this.dialogContent.querySelector('.mtg-dialog-content')
        this.buttonGroup = this.dialogContent.querySelector('.mtg-dialog-btn-group')

        if (typeof content === 'string') {
            this.panelContent.innerText = content
        } else if (content instanceof HTMLElement) {
            this.panelContent.appendChild(content)
        } else if (content instanceof VisibleComponent) {
            this.panelContent.appendChild(content.element)
        }

        this.initButtonGroup(buttonGroup)

        this.mask = new Mask({
            opacity: overlayerOpacity
        })
        let panelConfig = {
            width,
            height,
            title,
            titleAlign,
            titleTools,
            padding,
            wrapClassName,
            titleClassName,
            contentClassName,
            content: this.dialogContent,
        }
        this.panel = new Panel(panelConfig)

        this.mask.appendTo(this.element)
        this.panel.appendTo(this.mask)

        document.body.appendChild(this.element)
    }


    initButtonGroup(buttonGroup) {
        buttonGroup.forEach(config => {
            const btn = new Button(config)
            btn.appendTo(this.buttonGroup)
        })
    }

    show(duration) {
        console.log(this.mask)
        this.mask.show()
        if (duration) {
            setTimeout(() => {
                this.hide()
            }, duration)
        }
    }

    hide() {
        this.mask.hide()
    }


}

export default Dialog